// pie.vue
<template>
  <div class="container" id="pie">
    <!-- <div class="title">
      <v-row>
        <v-col cols="12" class="text-center">
          <span>ยอดขายของเดือน {{ getMonthFromYearMonth(selectedYearMonth) }}</span>
          <div class="tooltip">
            <v-icon dark left color="#707070" size="20px" style="margin-left: 10px">mdi-information-outline</v-icon>
            <span class="tooltiptext">ยอดขายไม่รวมภาษี</span>
          </div>
          <div class="tw-text-4xl tw-text-light-green tw-font-bold">
            {{ totalSales }} บาท
          </div>
        </v-col>
      </v-row>
    </div> -->
    <!-- {{ chartData }} -->
    <!-- vendorCode {{ vendorCode }} -->
    <div class="chart-container">
      <line-boundaries 
      :chartData="chartData" 
      :options="chartOptions" 
    />
    </div>
  </div>
</template>

<script>
import LineBoundaries from "./pieReport.vue";

export default {
  components: {
    LineBoundaries,
  },
  props: ["chartData", "companyID", "selectedCompany",  "startDate", "endDate", "companyList"],
  data() {
    return {
      selectedYearMonth: "2024-11",
      totalSales: 100,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.handleChartClick, // Add this line
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const dataset = data.datasets[tooltipItem.datasetIndex];
              const total = dataset.data.reduce((acc, data) => acc + data, 0);
              const currentValue = dataset.data[tooltipItem.index];
              const percentage = Math.round((currentValue / total) * 100);
              return `${data.labels[tooltipItem.index]}: ${percentage}%`;
            },
          },
        },
      },
    };
  },
  methods: {
    getMonthFromYearMonth(yearMonth) {
      const [year, month] = yearMonth.split("-");
      return `${month}/${year}`;
    },
    handleChartClick(event, elements) {
      if (elements.length > 0) {
        const index = elements[0]._index;
        const status = this.chartData.labels[index];
        const value = this.chartData.datasets[0].data[index];
        // Perform your desired action here
        const link = this.generateLink(this.$props.companyID, this.$props.selectedCompany, status, this.$props.startDate, this.$props.endDate)

        this.$router.push(link)
        console.log(`Clicked on ${status}: ${value} : ${this.companyID}, ${link}`);
      }
    },
    generateLink(companyID, selectedCompany, status, startDate, endDate) {
      if(status === 'PENDING'){
        status = 'PENDING_APPROVAL'
      }
      // Format startDate and endDate if they are provided
      const formattedStartDate = startDate
        ? encodeURIComponent(new Date(startDate).toISOString())
        : null;
      const formattedEndDate = endDate
        ? encodeURIComponent(new Date(endDate).toISOString())
        : null;

      let baseURL = "";

      if (status === "SUCCESS") {
        if (selectedCompany === "ALL") {
          baseURL = `/${companyID}/documentsoai?status=${status}`;
        } else {
          const selectedDoc = this.companyList.find((company) => {
            return company.value.trim() === selectedCompany.trim();
          });
          const companyValue = selectedDoc?.value || this.selectedCompany || "";
          baseURL = `/${companyID}/DocumentSOAIVendor/${companyValue}?status=${status}`;
        }
      } else {
        if (selectedCompany === "ALL") {
          baseURL = `/${companyID}/documentpoai?status=${status}`;
        } else {
          const selectedDoc = this.companyList.find((company) => {
            return company.value.trim() === selectedCompany.trim();
          });
          const companyValue = selectedDoc?.value || this.selectedCompany || "";
          baseURL = `/${companyID}/DocumentPOAIVendor/${companyValue}?status=${status}`;
        }
      }

      // Conditionally append startDate and endDate if they are defined
      const queryParams = [];
      if (formattedStartDate)
        queryParams.push(`startDate=${formattedStartDate}`);
      if (formattedEndDate) queryParams.push(`endDate=${formattedEndDate}`);

      if (queryParams.length > 0) {
        baseURL += `&${queryParams.join("&")}`;
      }

      return baseURL;
    },
  },
};
</script>

<style scoped>
.container {
  margin: 20px;
}
.title {
  margin-bottom: 20px;
}
.chart-container {
  width: 100%;
  height: 400px;
}
</style>
